import { apiSlice } from "./api/apiSlice";

export const telesalesDashboardSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    // Get complete telesales dashboard data
    getTelesalesDashboard: builder.query({
      query: ({ employeeId }) => ({
        url: `/telesales/dashboard/telesales-dashboard`,
        method: "GET",
        params: { employeeId },
      }),
      providesTags: ["TelesalesDashboard"],
      transformResponse: (response) => {
        if (response.success) {
          return response.data;
        }
        return null;
      },
      // Poll every 5 minutes for fresh data
      keepUnusedDataFor: 300,
    }),
  }),
});

export const {
  useGetTelesalesDashboardQuery,
  useLazyGetTelesalesDashboardQuery,
} = telesalesDashboardSlice;

